import { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { AppContext } from "../providers/AppProvider";
import styled from "@emotion/styled";
import { gql } from "../api";
import CircularProgress from "@mui/material/CircularProgress";
import BackButton from "../components/BackButton";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import Container from "@mui/material/Container";
import { useNavigate } from "react-router-dom";
import EventForm from "../components/EventForm";

const LoadingWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
`;

export default function EditEvent() {
  const { jwt } = useContext(AppContext);
  const { id, organizationId } = useParams();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [event, setEvent] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadEventData = async () => {
      setLoading(true);

      try {
        const query = `
          query {
            events (where: {id: $id}) {
              id
              title
              description
              image
              start_date
              start_time
              duration
              place
              public
              seats_quantity
              booking_confirmation
              recurring
              recurring_end_date
              recurring_frequency
              recurring_quantity
              recurring_weekdays
              recurring_booking
            }
          }
        `;

        const variables = { id };

        const result = await gql({ jwt, query, variables });
        if (result.error) {
          throw result.error;
        }

        if (result.content.events.length === 0) {
          throw new Error("Event not found");
        }

        const evt = result.content.events[0];
        setEvent(evt);
      } catch (err) {
        console.log("error", err);
      }

      setLoading(false);
    };

    loadEventData();
  }, [id, jwt]);

  const submit = async (data) => {
    setError(false); // TODO: Handle errors

    // TODO: validate input data
    try {
      const query = `
        mutation {
          events (update: $data, where: { id: $id }) {}
        }
      `;

      const variables = { id, data };

      const result = await gql({ jwt, query, variables, organizationId });
      if (result.error) {
        throw result.error;
      }

      navigate(`/organizations/${organizationId}/events`);
    } catch (err) {
      console.log("error", err);
    }
  };

  return loading ? (
    <LoadingWrapper>
      <CircularProgress />
    </LoadingWrapper>
  ) : (
    <>
      <Title>
        <BackButton />
        <Typography component="h1" variant="h5" color="inherit">
          Edit Event
        </Typography>
      </Title>
      <Container component="main" maxWidth="sm">
        <EventForm event={event} onSubmit={submit} />
        {error && (
          <Alert severity="error">Could not save event, try again later.</Alert>
        )}
      </Container>
    </>
  );
}
